export const ANON_SECTION: string = "anonymous-section";